import { Button } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { Navigate } from 'react-router-dom';
import PrivateLayout from '../templates/PrivateLayout';
import { api } from '../axiosInstance/axiosInstance';
import { useAuth } from '../context/AuthProvider';
import { useEffect, useState } from 'react';
import { IoLogoGooglePlaystore } from "react-icons/io5";
import { FaApple } from "react-icons/fa";


const Dashboard = () => {
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Dashboard | Fonoaudiologia na Prática";

    return () => {
      document.title = previousTitle;
    };
  }, []);
  if (!user?.has_plan) {
    return <Navigate to="/planos" replace />;
  }

  async function managePlans() {
    setIsLoading(true)
    try {
      const response = await api.post("/manage-plan", {
        use_id: user?.use_id
      });
      window.location.replace(response?.data?.redirect_url);
      setIsLoading(false)

    } catch (error) {
      console.error("Ocorreu um erro", error);
      window.location.replace("https://dashboard.stripe.com/products");

    }
  }

  return (
    <PrivateLayout>
      <div className="flex flex-col items-center  min-h-screen bg-white">
        <div className="w-full max-w-lg p-8 shadow-sm rounded-lg">
          <h1 className="text-2xl font-bold text-center text-gray-800 mb-2">Assinatura Confirmada</h1>

          <div className="text-center mb-6">
            <div className="flex flex-col items-center mb-6">
              <CheckCircleOutlined style={{ color: "green", fontSize: '30px' }} />
              <h2 className="text-2xl font-semibold text-gray-700 mt-4">Parabéns!</h2>
              <p className="text-gray-600 mt-1">Você pode baixar o aplicativo.</p>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-4">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://play.google.com/store/apps/details?id=com.projetofono.fonotherapp"
                className="flex items-center justify-center w-full sm:w-auto px-4 py-3 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition duration-300 gap-2"
              >
                <IoLogoGooglePlaystore className="text-lg" />
                Baixar na Play Store
              </a>

              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://apps.apple.com/br/app/fonotherapp/id6738363190"
                className="flex items-center justify-center w-full sm:w-auto px-4 py-3 bg-black text-white font-medium rounded-lg hover:bg-gray-800 transition duration-300 gap-2"
              >
                <FaApple className="text-lg" />
                Baixar na App Store
              </a>

            </div>

            <Button
              loading={isLoading}
              type="primary"
              className="mt-6 w-full h-12 text-[17px] bg-primary text-white py-3 font-medium rounded-lg hover:bg-cyan-500 transition duration-300"
              onClick={managePlans}
            >
              Gerenciar Plano
            </Button>
          </div>
        </div>
      </div>
    </PrivateLayout>
  );
};

export default Dashboard;
